import QuestionViewerLayout from '@/layouts/QuestionViewerLayout.vue';

const questionViewerRoutes = [
  {
    path: '/question-viewer',
    component: QuestionViewerLayout,
    meta: { 
      requiresAuth: true,
      role: '7'  // 查看人员的角色ID
    },
    children: [
      {
        path: '',
        redirect: 'dashboard'
      },
      {
        path: 'dashboard',
        name: 'ViewerDashboard',
        component: () => import('@/views/viewer/Dashboard.vue'),
        meta: { title: '题库系统' }
      },
      {
        path: 'bank/:bankId',
        name: 'ViewerBankDetail',
        component: () => import('@/views/viewer/BankDetail.vue'),
        meta: { title: '题库详情' }
      },
      {
        path: 'favorites',
        name: 'ViewerFavorites',
        component: () => import('@/views/viewer/FavoriteFolders.vue'),
        meta: { title: '我的收藏' }
      },
      {
        path: 'favorites/folder/:folderId',
        name: 'ViewerFavoriteDetail',
        component: () => import('@/views/viewer/FavoriteDetail.vue'),
        meta: { title: '收藏夹详情' }
      }
    ]
  }
];

export default questionViewerRoutes; 